import {
  ApiCartChangeCartDeliveryModeFailedAction,
  ApiCartChangeCartDeliveryModeSucceededAction,
  apiCartChangeCartDeliveryModeFailedType,
  apiCartChangeCartDeliveryModeRequested,
  apiCartChangeCartDeliveryModeSucceededType
} from '../../api/cart/changeCartDeliveryModeApi';
import {
  ChangeCurrentCartDeliveryModeRequestedAction,
  changeCurrentCartDeliveryModeFailed,
  changeCurrentCartDeliveryModeSucceeded
} from '../../carts/cartsSlice';
import { put, race, take } from 'typed-redux-saga';
import { ChangeCartDeliveryModeResult } from '../../../graphql/cart/changeCartDeliveryMode';
import { CustomOrderType } from '../../carts/CustomOrderType';
import convertCartToStateCart from '../../../converters/convertCartToStateCart';
import generateActionId from '../../../generateActionId';

function* changeCurrentCartDeliveryModeSaga({
  payload: { actionId: requestedActionId, customOrderType }
}: ChangeCurrentCartDeliveryModeRequestedAction): Generator {
  const actionId: number = generateActionId();
  yield* put(
    apiCartChangeCartDeliveryModeRequested({
      actionId,
      customOrderType,
      parentActionId: requestedActionId
    })
  );

  yield* actionsLoop(actionId, requestedActionId, customOrderType);
}

function* actionsLoop(
  actionId: number,
  requestedActionId: number,
  customOrderType: CustomOrderType
): Generator {
  let isSameActionId: boolean = false;
  do {
    const { succeeded, failed } = yield* race({
      succeeded: take<ApiCartChangeCartDeliveryModeSucceededAction>(
        apiCartChangeCartDeliveryModeSucceededType
      ),
      failed: take<ApiCartChangeCartDeliveryModeFailedAction>(
        apiCartChangeCartDeliveryModeFailedType
      )
    });

    isSameActionId =
      succeeded?.payload.requestedActionId === actionId ||
      failed?.payload.requestedActionId === actionId;

    if (isSameActionId) {
      if (succeeded !== undefined) {
        const result: ChangeCartDeliveryModeResult = succeeded.payload.result;
        if (result.__typename === 'ChangeCartDeliveryModeFailedResult') {
          yield* put(
            changeCurrentCartDeliveryModeFailed({
              requestedActionId
            })
          );
        } else {
          yield* put(
            changeCurrentCartDeliveryModeSucceeded({
              cart: convertCartToStateCart(result.cart),
              customOrderType,
              requestedActionId
            })
          );
        }
      } else if (failed !== undefined) {
        yield* put(
          changeCurrentCartDeliveryModeFailed({
            requestedActionId
          })
        );
      }
    }
  } while (!isSameActionId);
}

export default changeCurrentCartDeliveryModeSaga;
